<template>
  <v-card outlined elevation="0" style="border: none">
    <v-card-text class="pt-1">
      <v-row class="px-1 mb-1">
        <v-col>
          <div>
            <span class="mtitle"
              >{{ $t("message.pageKm.loco", { value: "default" }) }} :</span
            >
            <span class="value">{{ captrainItem.group }}</span>
          </div>
          <div>
            <span class="mtitle"
              >Start location :</span
            >
            <span class="value">{{ captrainItem.startLocation }}</span>
          </div>
          <div>
            <span class="mtitle"
              >End location :</span
            >
            <span class="value">{{ captrainItem.endLocation }}</span>
          </div>
        </v-col>
      </v-row>
      <v-divider class="mb-4"></v-divider>

      <v-row class="px-2 mb-2">
        <v-col>
          <div>
            <span class="mtitle"
              >Start date :</span
            >
            <span class="value">{{ formatdate(captrainItem.start) }}</span>
          </div>
          <div>
            <span class="mtitle"
              >End date :</span
            >
            <span class="value">{{ formatdate(captrainItem.end) }}</span>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { formatMagicDate } from "@/shared/DateHelper";
export default {
  props: ["captrainItem"],

  methods: {  
    formatdate(date) {
      return formatMagicDate(date);
    },
  },
 
};
</script>

<style scoped>

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 16px;
  font-weight: bolder;
}

.value {
  font-size: 16px;
}
</style>
